import React, { useEffect, useState } from "react";
import DialogWrap, { DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import {
	UserFormServiceButtonClose,
	UserFormServiceButtonCreated,
} from "../../MyBooking/styled/DesStyled";
import { updatePartnerWalkingDistance } from "../../../../services/PartnerService";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { TextField } from "@material-ui/core";
import usePartnerDetail from "../hook/useGetUserDetail";

export default function DialogWalkingDistancePartner(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	partnerId: string;
	walkingDistance?: string | null;
	reload: () => void;
}) {
	const { openAlertDialog } = useAlertDialog();
	const { userDetail } = usePartnerDetail({ id: props.partnerId, openDialog: props.openDialog });
	const [walkingDistance, setWalkingDistance] = useState(props.walkingDistance || "");

	useEffect(() => {
		if (userDetail) {
			setWalkingDistance(userDetail.walkingDistance || "");
		} else {
			setWalkingDistance(props.walkingDistance || "");
		}
	}, [userDetail, props.walkingDistance]);

	const handleSave = async () => {
		try {
			await updatePartnerWalkingDistance(props.partnerId, walkingDistance);
			openAlertDialog?.(AlertType.Success, "Update successfully!", () => {
				props.reload?.();
			});
			props.setOpenDialog(false);
		} catch (err) {
			console.error("Error updating walking distance:", err);
			openAlertDialog?.(AlertType.Fail, "Failed to update walking distance");
		}
	};

	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Update Walking Distance"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Cancel
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
				</>
			}>
			<div style={{ marginBottom: '20px' }}>
				<TextField
					fullWidth
					multiline
					rows={4}
					label="Walking Distance"
					placeholder="6 min from Hoan Kiem Lake&#10;9 min from Hoa Lo Prison"
					value={walkingDistance}
					onChange={(e) => setWalkingDistance(e.target.value)}
					helperText="Enter walking distances, one per line. Use &lt;br /&gt; for line breaks in HTML."
				/>
			</div>
		</DialogWrapMedium>
	);
}

